import { useEffect } from 'react'
import { TrackingService } from './tracking.service'
import { preventAnalyticLoading } from '../../features/analytics/utils'
import loadSegmentScript from '../../features/analytics/uglySegmentScript'
import { SEGMENT_TOKEN, REACT_APP_AMPLITUDE_API_KEY } from '../../environment/analytics'
import { useLocation } from 'react-router-dom'

export const useTrackingService = () => {
  const location = useLocation()

  useEffect(() => {
    if (!preventAnalyticLoading(document)) {
      // Segment : transport par défaut pour les événements non encore migrés.
      loadSegmentScript(SEGMENT_TOKEN)
      window.analytics.debug(false)

      // Amplitude : cible de la migration, uniquement pour les événements flagués.
      if (REACT_APP_AMPLITUDE_API_KEY) {
        TrackingService.initAmplitude(REACT_APP_AMPLITUDE_API_KEY)
      }
    }
  }, [])

  useEffect(() => {
    if (!preventAnalyticLoading(document)) {
      TrackingService.page(location.pathname)
    }
  }, [location])
}
